import { Collapse, Icon } from '@octano/global-ui';
import { useMemo } from 'react';
import { Col, Row } from 'reactstrap';
import SectionShowSchedule from '../../../SectionsMaintainer/parts/SectionShowSchedule';
import { useContinuousEducationSectionSchedulesLoaderData } from '../hooks/ContinuousEducationSectionSchedulesLoader';
import SectionScheduleForm from './SectionScheduleForm';

const SectionSchedulesTab = () => {
  const data = useContinuousEducationSectionSchedulesLoaderData();

  const options = useMemo(() => {
    if (!data) {
      return {
        scheduleModules: [],
        scheduleLegends: [],
      };
    }

    return {
      scheduleModules: data.timeModules,
      scheduleLegends: data.activities,
    };
  }, [data]);

  const refresh = () => {
    // TO-DO: implement refresh logic if needed
  };

  if (!data) {
    return <></>;
  }

  return (
    <Row className="mt-4">
      <Col xs={12}>
        <div
          className="d-flex justify-content-between align-items-center bg-primary text-white px-4 py-3"
          style={{
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
          }}
        >
          <span className="fw-bold">Concepto</span>
          <span className="fs-14">Ver más</span>
        </div>

        <Collapse
          renderTitle={() => (
            <p className="fs-14 fw-600 my-auto ml-1 text-dark">Clases</p>
          )}
          headerStyles={{
            backgroundColor: '#fff',
            height: 60,
            paddingLeft: '1.5rem',
            paddingRight: '1.5rem',
          }}
          contentClassName="pt-3 border-left border-right border-bottom border-light"
          renderBtn={({ isOpened, toggle }) => (
            <div onClick={toggle} className="cursor-pointer mr-3">
              <Icon name={isOpened ? 'chevron_up' : 'chevron_right'} />
            </div>
          )}
        >
          <SectionScheduleForm data={data} onSave={refresh} />
        </Collapse>

        <Collapse
          renderTitle={() => (
            <p className="fs-14 fw-600 my-auto ml-1 text-dark">Horario</p>
          )}
          headerStyles={{
            backgroundColor: '#f8f9fa',
            height: 60,
            paddingLeft: '1.5rem',
            paddingRight: '1.5rem',
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
          }}
          contentClassName="pt-3 border-left border-right border-bottom border-light"
          renderBtn={({ isOpened, toggle }) => (
            <div onClick={toggle} className="cursor-pointer mr-3">
              <Icon name={isOpened ? 'chevron_up' : 'chevron_right'} />
            </div>
          )}
        >
          <SectionShowSchedule
            section={data.section}
            sectionSchedules={data.section.sectionSchedules.filter(
              (schedule) => !schedule.deletedAt,
            )}
            modules={options.scheduleModules}
            legends={options.scheduleLegends}
          />
        </Collapse>
      </Col>
    </Row>
  );
};

export default SectionSchedulesTab;
